import axios from "axios";
import apiURI from "./Api";
import { typeTransfer } from "../pages/UserDashboard/components/WithdrawIntent/WithdrawIntent";

export default class WalletService {
  async postWithdrawIntent(
    token,
    username,
    amount,
    email = null,
    type = typeTransfer.PAYPAL,
    bankName = null,
    bankAccountNumber = null,
    accountOwner = null,
  ) {
    let bodyJson = {};
    if (type === typeTransfer.PAYPAL) {
      bodyJson = {
        amount: amount,
        user: { username: username },
        paypalEmailToTransfer: email,
        typeWithdraw: typeTransfer.PAYPAL,
      };
    } else {
      bodyJson = {
        amount: amount,
        user: { username: username },
        typeWithdraw: typeTransfer.BANK,
        bankname: bankName,
        iban: bankAccountNumber,
        accountOwner: accountOwner,
      };
    }

    const response = await axios({
      method: "post",
      url: `${apiURI}/withdraw/intent`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postWithdrawRequest(
    token,
    username,
    amount,
    email,
    otp,
    type = typeTransfer.PAYPAL,
    bankName = null,
    bankAccountNumber = null,
    accountOwner = null,
  ) {
    let bodyJson = {};
    if (type === typeTransfer.PAYPAL) {
      bodyJson = {
        amount: amount,
        user: { username: username },
        paypalEmailToTransfer: email,
        passwordfinantial: otp,
      };
    } else {
      bodyJson = {
        amount: amount,
        user: { username: username },
        passwordfinantial: otp,
        typeWithdraw: typeTransfer.BANK,
        bankname: bankName,
        iban: bankAccountNumber,
        accountOwner: accountOwner,
      };
    }

    const response = await axios({
      method: "post",
      url: `${apiURI}/withdraw/request`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getWithdrawOtp(token, username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/withdraw/requestotp/${username}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getPreviousPaypal() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/withdraw/getPreviousPaypal/${localStorage.getItem("__extraconomy_username")}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async getPreviousBank() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/withdraw/getPreviousBanks/${localStorage.getItem("__extraconomy_username")}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async getLifetimeBonusTransactions(token, username, dateBegin, dateEnd) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/walletlifetimebonus/transactions/${username}/datebegin/${dateBegin}/dateend/${dateEnd}`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
